__turbopack_context__.v({
  "CSSProvider": "OVmoKq_CSSProvider",
  "CSSScrollControlSvg": "OVmoKq_CSSScrollControlSvg",
  "CinemaOnly": "OVmoKq_CinemaOnly",
  "SCinemaProvider": "OVmoKq_SCinemaProvider" + " " + "OVmoKq_CSSProvider",
  "SLeftArrowSvg": "OVmoKq_SLeftArrowSvg" + " " + "OVmoKq_CSSScrollControlSvg",
  "SProviderList": "OVmoKq_SProviderList",
  "SProviderScrollerContainer": "OVmoKq_SProviderScrollerContainer",
  "SRightArrowSvg": "OVmoKq_SRightArrowSvg" + " " + "OVmoKq_CSSScrollControlSvg",
  "SScrollerButton": "OVmoKq_SScrollerButton",
  "SStreamingProvider": "OVmoKq_SStreamingProvider" + " " + "OVmoKq_CSSProvider",
});
